<template>
  <v-edit-dialog
    v-model="textDialog"
    lazy
    large
    cancel-text="Отмена"
    save-text="Ок"
    @cancel="closeDialog()"
    @open="tmpItem = item"
    @save="change(item)"
  >
    <div class="link">
      {{ item || "_" }}
    </div>
    <template v-slot:input>
      <v-text-field
        v-model="item"
        class="ma-2"
        outline
        height="44"
        hide-details
      />
    </template>
  </v-edit-dialog>
</template>
<script>
export default {
  props: ["value", "routeItem", "column"],
  data() {
    return {
      textDialog: false,
      tmpItem: null,
      item: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.item = val;
      },
      immediate: true,
    },
  },
  methods: {
    closeDialog() {
      this.item = this.tmpItem;
      this.tmpItem = null;
    },
    change(value) {
      const item = { ...this.routeItem };
      item[this.column] = value;
      this.$store.commit("route/setEditableRouteItem", item);
      this.tmpItem = null;
      this.item = null;
      this.$emit("change");
    },
  },
};
</script>
